import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {ContactComponent} from './contact.component';
import {ComponentsModule} from '../../../components/components.module';
import {TableModule} from 'primeng/table';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DialogModule} from 'primeng/dialog';
import {ContactEditComponent} from './contact-edit/contact-edit.component';
import {RouterModule} from '@angular/router';
import {InputTextModule} from 'primeng/inputtext';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CheckboxModule} from 'primeng/checkbox';
import {ToastModule} from 'primeng/toast';
import {ButtonModule} from 'primeng/button';
import { PipesModule } from '../../../pipes/pipes.module';


@NgModule({
    declarations: [ContactComponent, ContactEditComponent],
    imports: [
        CommonModule,
        TranslateModule,
        ComponentsModule,
        TableModule,
        ConfirmDialogModule,
        DialogModule,
        RouterModule,
        InputTextModule,
        DropdownModule,
        FormsModule,
        ReactiveFormsModule,
        CheckboxModule,
        ToastModule,
        ButtonModule,
        PipesModule
    ],
    exports: [ContactComponent, ContactEditComponent]
})
export class ContactModule { }
